<template>
    <div id="app">
        <Header/>
        <router-view :account-id="accountId"/>
        <Footer/>
    </div>
</template>


<script>

    import Header from './Header'
    import Footer from './Footer'

    export default {
        props: {
            accountId: {
                type: String
            }
        },
        components: {
            Header,
            Footer
        }
    }

</script>
